var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacebookIconSmall = function SvgFacebookIconSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#3b5998;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M647.9219,528.23a1.9289,1.9289,0,0,1-1.93,1.93H637.07V516.6123h4.5469l.68-5.2812h-5.2344v-3.375c0-1.5313.4219-2.57,2.6172-2.57h2.7969v-4.7265a37.5988,37.5988,0,0,0-4.0782-.211c-4.0312,0-6.7968,2.461-6.7968,6.9844v3.8985h-4.5625v5.2812h4.5625V530.167h-16.75a1.9339,1.9339,0,0,1-1.93-1.93V497.0967a1.9339,1.9339,0,0,1,1.93-1.93h31.1328a1.9355,1.9355,0,0,1,1.9375,1.93Z",
    transform: "translate(-612.9219 -495.167)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookIconSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "facebook-icon-small.a1052a96fb5fae63c05d22eb72dee919.svg";